import * as filepicker from 'filepicker-js';

filepicker.setKey('AN9KvhoveSgapUFDh8Lz5z');
const conversionOptions = {
  width: 400,
  fit: 'clip',
  compress: true,
  quality: 80,
};

/**
 * stores a file in filepicker
 *
 * @param file File
 * @param success onSuccess callback
 * @param error onError callback
 */
function store(file: File, success: Function, error: Function): void {
  //get a filepicker blob object by storing the file
  filepicker.store(file, (blob) => {
    //convert the file using conversion options
    filepicker.convert(blob, conversionOptions, (convertedFile) => {
      //store the final version of the file
      filepicker.store(convertedFile, success, error);
    });
  });
}
export { store };
